export function isMyVTEX(url: any): boolean {
  const regex = /^https:\/\/[a-zA-Z0-9-]+\.myvtex\.com/;
  return regex.test(String(url));
}

export const getPageUrl = () => window?.location?.href;
